<template>

    <div>
        <b-breadcrumb class="text-capitalize">
            <b-breadcrumb-item :to="{ name: 'AthleteList' }"><font-awesome-icon icon="caret-right" class="mr-1" />Athletes</b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'AthleteList' }">{{athleteName.truncate(32)}}</b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'SessionList' }" active>Sessions</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="container-fluid px-4">

            <b-card class="mb-3" title="Sessions" sub-title="Select an athlete to review past and live sessions.">

                <b-input-group size="sm">
                    <template v-slot:prepend>
                        <b-input-group-text >
                            <font-awesome-icon icon="running" class="mx-1" />
                        </b-input-group-text>
                    </template>
                    <b-form-select v-model="selectedAthleteId" :options="athleteOptions" v-on:change="refreshAthlete">
                        <template v-slot:first>
                            <b-form-select-option :value="null">-- All Athletes --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-input-group>
            </b-card>

          <b-card class="my-1">
            <div class="container-fluid p-0 my-0">
                <div class="row no-gutters justify-content-start">
                    <div class="col">
                        <b-input-group size="sm" class="my-1">
                            <b-input-group-prepend>
                                <b-button variant="outline-secondary" v-on:click.stop="refreshTable()">
                                    <font-awesome-icon icon="sync-alt" class="mx-1"/>
                                    Refresh
                                </b-button>
                            </b-input-group-prepend>
                            <b-input-group-prepend>
                                <b-input-group-text >
                                    <font-awesome-icon icon="search" class="mx-1" />
                                </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input v-model="searchTerm" placeholder="Search"></b-form-input>
                            <b-input-group-prepend>
                              <b-input-group-text >
                                <font-awesome-icon icon="calendar" class="mx-1" />
                              </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-select v-model="selectedRange" :options="rangeOptions" v-on:change="refreshTable"></b-form-select>
                        </b-input-group>
                    </div>
                </div>
            </div>
          </b-card>


            <b-overlay :show="isLoading"
                       rounded="sm">

                <ErrorView :visible="isLoadingError" :errorValue="loadingErrorValue"/>

                <vue-good-table v-if="isLoadingError == false" styleClass="vgt-table bordered striped condensed"
                        :columns="columns"
                        :rows="groupedItems"
                        :search-options="{
                            enabled: true,
                            externalQuery: searchTerm
                        }"
                        :pagination-options="{
                            enabled: true,
                            position: 'bottom',
                            perPage: 25,
                            dropdownAllowAll: false,
                            perPageDropdown: [25, 50, 100],
                        }"
                        :groupOptions="{ enabled: true }"
                        @on-row-click="onRowClick">
                    <div slot="emptystate">
                      No session found for selected filter options.
                    </div>
                    <template slot="table-header-row" slot-scope="props">
                          <span class="group-row-header">
                            {{ props.row.label }}
                          </span>
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'startTime'">
                          <span>{{props.row.startTime | moment("h:mm a")}}</span>
                        </span>
                        <span v-else-if="props.column.field == 'state'">
                           <SessionStatus :state="props.row.state"/>
                        </span>
                        <span v-else-if="props.column.field == 'name'">
                           <SessionIcon class="mr-1" :session="props.row"/>
                           <div style="display: inline-block; vertical-align: middle;">
                             <span>{{props.formattedRow[props.column.field].truncate(28)}}</span>
                             <br/>
                             <span style="font-size: x-small; color: #cccccc">ID:{{props.row.sessionId}}</span>
                           </div>
                        </span>
                        <span v-else-if="props.column.field == 'action'">
                            <div class="float-right">
                                <b-button size="sm" class="mx-2" variant="outline-danger" v-on:click.stop="onDelete(props.row)">
                                    <font-awesome-icon icon="trash" />
                                </b-button>
                            </div>
                        </span>
                        <span v-else>
                          {{props.formattedRow[props.column.field]}}
                        </span>
                    </template>
                </vue-good-table>
            </b-overlay>

        </div>

        <SessionDeleteModal />
    </div>

</template>
<script>

    import { mapActions, mapGetters } from 'vuex'
    import { VueGoodTable } from 'vue-good-table';
    import SessionStatus from './SessionStatus';
    import SessionIcon from './SessionIcon';
    import SessionDeleteModal from './SessionDeleteModal';
    import ErrorView from '../ErrorView'


    import moment from 'moment'


    export default {
        name: "SessionsPage",
        components: {
            VueGoodTable,
            SessionStatus,
            SessionIcon,
            SessionDeleteModal,
            ErrorView
        },
        data() {
            return {
                athleteId: this.$route.params.athleteId,
                organizationId: this.$route.params.orgId,

                athleteOptions: [],
                selectedAthleteId: null,

                selectedRange: 'days365',
                rangeOptions: [
                  { value: 'days30', text: 'Last 30 Days' },
                  { value: 'days60', text: 'Last 60 Days' },
                  { value: 'days90', text: 'Last 90 Days' },
                  { value: 'days180', text: 'Last 6 Months' },
                  { value: 'days365', text: 'Last year' },
                  { value: 'all', text: 'All' },
                ],

                searchTerm: '',
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                        sortable: true,
                    },
                    {
                        label: 'Start',
                        field: 'startTime',
                        sortable: true,
                    },
                    {
                      label: 'Status',
                      field: 'state',
                      sortable: true,
                    },
                    {
                        label: '',
                        field: 'action',
                        sortable: false,
                    },
                ],
            }
        },
        computed: {
            ...mapGetters({
                items: 'session/items',
                itemsLoading: 'session/itemsLoading',
                itemsLoadingError: 'session/itemsLoadingError',
                itemsLoadingErrorValue: 'session/itemsLoadingErrorValue',
                itemsDirty: 'session/itemsDirty',

                organization: 'organization/current',

                athlete: 'athlete/current',
                athleteLoading: 'athlete/currentLoading',
                athleteName: 'athlete/currentName',
                athleteItems: 'athlete/items',
                athleteItemsLoading: 'athlete/itemsLoading',
                athleteItemsDirty: 'athlete/itemsDirty',
            }),

            isLoading() {
                return this.itemsLoading || this.athleteLoading
            },
            isLoadingError: function() {
                return this.itemsLoadingError || (!this.isLoading && !this.items);
            },
            loadingErrorValue: function() {
                return this.itemsLoadingErrorValue;
            },

            groupedItems() {

                let items = this.items.data;
                if(items) {

                    let grouped = items.reduce(function (h, obj) {
                        let key = '-';
                        if(obj.startTimeObject) {
                            key = moment(obj.startTimeObject).format('dddd, MMMM Do YYYY');
                        }

                        let group = (h[key] || {
                            date: obj.startTimeObject,
                            mode: "span",
                            label: key,
                            html: false,
                            children: []
                        });

                        group.children.push(obj);

                        h[key] = group;

                        return h;
                    }, {});

                    let rows = Object.keys(grouped).map(function(key) {
                        return grouped[key];
                    });

                    let sorted = rows.sort(function(a, b) {
                        let dateA = a.date, dateB = b.date;
                        if(!dateA || dateA == '')
                            return -1;
                        if(!dateB || dateB == '')
                            return 1;

                        return dateB - dateA;
                    });

                    return sorted;
                }

                return [];
            }
        },
        created () {
            if(!this.organizationId) {
                //navigate to org list
                this.$router.push({name: 'OrganizationList'});
            } else {
                this.refreshOrganization();

                this.selectedAthleteId = this.athleteId;
                if (this.selectedAthleteId == undefined) {

                    this.selectedAthleteId = null;
                    if(this.athlete && this.athlete.organizationId == this.organizationId) {
                      this.selectedAthleteId = this.athlete.athleteId;
                    }
                }

                let selectFirstAthlete = !this.selectedAthleteId;
                this.refreshAthlete(selectFirstAthlete);

                this.$sessionHub.sessionsOpened(this.organizationId, this.selectedAthleteId);
                this.$sessionHub.$on('session-created', this.onSessionCreated);
                this.$sessionHub.$on('session-changed', this.onSessionChanged);
            }
        },
        beforeDestroy () {
            // Notify the server we stopped watching the question
            this.$sessionHub.$off('session-created', this.onSessionCreated);
            this.$sessionHub.$off('session-changed', this.onSessionChanged);
            this.$sessionHub.sessionsClosed(this.organizationId, this.selectedAthleteId);
        },
        watch: {
            selectedAthleteId(newValue, oldValue) {

                if(oldValue) {
                  this.$sessionHub.sessionsClosed(this.organizationId, oldValue);
                }

                if(newValue) {
                    this.$sessionHub.sessionsOpened(this.organizationId, newValue);

                    if(oldValue) {
                      //fix current route to include latest org\athlete params
                      this.$router.replace({
                        name: 'SessionList',
                        params: {
                          organizationId: this.organizationId,
                          athleteId: newValue
                        }
                      });
                    }
                }
            },
            itemsDirty(newValue) {
                if(newValue) {
                    this.refreshTable()
                }
            },
            athleteItemsDirty(newValue) {
                if(newValue) {
                    this.refreshAthleteList()
                }
            }
        },
        methods: {
            ...mapActions({

                selectOrganization: 'organization/select',

                selectSession: 'session/select',
                listSessions: 'session/list',


                selectAthlete: 'athlete/select',
                listAthletes: 'athlete/list',

            }),
            refreshOrganization() {
                this.selectOrganization(this.organizationId)
            },
            refreshAthlete(selectFirstItem) {
                let self = this;

                return this.selectAthlete(this.selectedAthleteId).then( () => {

                    if(!self.athleteOptions || self.athleteOptions.length < 1) {
                        return self.refreshAthleteList(selectFirstItem);
                    } else {
                        return self.refreshTable();
                    }
                });
            },
            refreshAthleteList(selectFirstItem) {
                let self = this;

                self.athleteOptions = [];
                return this.listAthletes().then( result => {
                    self.athleteOptions = [];

                    if(result) {
                        result.data.forEach(item => {
                            self.athleteOptions.push({
                                text: item.sanitizedName + '            (' + item.summary + ')',
                                value: item.athleteId
                            });
                        });
                    }

                    if(selectFirstItem && self.athleteOptions.length > 0) {
                        self.selectedAthleteId = self.athleteOptions[0].value;
                        return self.refreshAthlete();
                    } else {
                        return self.refreshTable();
                    }
                });
            },

            getProtocolIcon(protocolPlan) {

              let path = 'icon_test_free.png';
              if(protocolPlan && protocolPlan.type) {

                if(protocolPlan.type == 'stepTest') {
                  path = 'icon_test_step.png';
                } else if(protocolPlan.type == 'intervalTest') {
                  path = 'icon_test_interval.png';
                } else if(protocolPlan.type == 'fiveOneFiveTest') {
                  path = 'icon_test_515.png';
                } else if(protocolPlan.type == 'restingTest') {
                  path = 'icon_test_resting.png';
                }

              }

              return require('../../assets/' + path);
            },

            refreshTable() {
                return this.listSessions( { athleteId: this.selectedAthleteId ?? '', rangeLimit: this.selectedRange ?? 'all' });
            },
            onRowClick(params) {
                this.$router.push({name: 'Session', params: { athleteId: params.row.athleteId, sessionId: params.row.sessionId}})
            },
            onDelete(model) {
                this.selectSession(model.sessionId)
                this.$bvModal.show('delete-session-modal')
            },

            onSessionCreated({sessionMeta}) {
                if (!sessionMeta || this.organizationId != sessionMeta.organizationId)
                    return;

                this.refreshTable();
            },
            onSessionChanged({sessionMeta}) {
                if (!sessionMeta || this.organizationId != sessionMeta.organizationId)
                    return;

                this.refreshTable();
            },
        }
    }
</script>

<style scoped>

    .group-row-header {
        font-size: small;
        font-weight: bold;
    }

</style>